<div class="container-fluid px-0" *ngIf="emailVerification && sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="combined-shape">
        <img [src]="'assets/images/message.png'" alt="logo"/>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label
        class="forgot-password-title">{{this.textService.keyValueMapping('forgotPinEmailConfirmationHeader', 'E-posta Doğrulama', sdkInitTexts)}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="information"
             *ngIf="hasVerificationEmail">{{this.textService.keyValueMapping('forgotPinEmailConfirmationText', 'Aşağıdaki mail adresinize doğrulama maili için link gönderilmiştir.', sdkInitTexts)}}</label>
      <label class="information"
             *ngIf="!hasVerificationEmail">{{this.textService.keyValueMapping('forgotPinEmailConfirmationDescription', 'Aşağıdaki adrese önceden E-posta', sdkInitTexts)}}
        <br>
        {{this.textService.keyValueMapping('forgotPinEmailConfirmationDescriptionContinue', 'gönderilmiştir.Lütfen E-posta adresinizi doğrulayın.', sdkInitTexts)}}
        <br>{{this.textService.keyValueMapping('forgotPinEmailConfirmatinSubDescription', 'Eğer önceki maili bulamıyorsanız doğrulama e-postası gönder butonuna basınız.', sdkInitTexts)}}
      </label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="mail-text">{{email}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center" *ngIf="!hasVerificationEmail">
      <button class="button-style" (click)="sendVerificationEmail()"><span
        class="button-text">{{this.textService.keyValueMapping('forgotPinEmailConfirmationSendButton', 'Doğrulama E-Postası Gönder', sdkInitTexts)}}</span>
      </button>
    </div>
  </div>
</div>
<div class="container-fluid px-0" *ngIf="!emailVerification && sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="combined-shape">
        <img [src]="'assets/images/message.png'" alt="logo"/>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label *ngIf="!hasSendEmail"
             class="forgot-password-title">{{this.textService.keyValueMapping('forgotPasswordButton', 'Şifremi Unuttum', sdkInitTexts)}}</label>
      <label *ngIf="hasSendEmail"
             class="forgot-password-title">{{this.textService.keyValueMapping('forgotPinCheckEmailHeader', 'E-postanızı kontrol edin', sdkInitTexts)}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label *ngIf="!hasSendEmail"
             class="information">{{this.textService.keyValueMapping('forgotPinCheckEmailText1', 'Aşağıdaki adresinize şifre yenileme için e-posta', sdkInitTexts)}}
        <br>
        {{this.textService.keyValueMapping('forgotPinCheckEmailText2', 'gönderilecek. E-posta adresiniz değiştirmek için', sdkInitTexts)}}
        <br> <span
          class="text-style">{{this.textService.keyValueMapping('forgotPinCheckEmailText3', '0850 622 6060', sdkInitTexts)}}</span>
        {{this.textService.keyValueMapping('forgotPinCheckEmailText4', '\'ı arayabilirsiniz\n', sdkInitTexts)}}</label>
      <label *ngIf="hasSendEmail" class="information">
        {{this.textService.keyValueMapping('forgotPinCheckEmailDescription', 'Aşağıdaki mail adresinize şifre oluşturma linki gönderilmiştir.', sdkInitTexts)}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="mail-text">{{email}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <button class="button-style" (click)="sendRecoveryEmail()"><span
        class="button-text">{{hasSendEmail ? 'Tekrar Gönder' : 'E-posta gönder'}}</span>
      </button>
    </div>
  </div>
</div>
